export function addItem(array, item) {
  return [...array, item];
}

export function removeItem(array, item) {
  return array.filter((i) => i !== item);
}

export function insertAt(array, index, ...elements) {
  return array.splice(index, 0, ...elements);
}
